export function addCurrent(faqsubject) {
    return {
        type: 'ADD_CURRENT',
        faqsubject,
    }
}
